import React, {useEffect, useMemo, useState} from "react";
import './co.scss'
import {Select} from "../select/select";
import {change, getData, service, trim, widthStore} from "../../stores/util";
import {history} from "../../history";
import {userStore} from "../../stores/userStore";


export const hisFooter = (t0, isNoLo) => d => {
    const {
        sum: {
            profit,
            betAmount,
            netPnl,
            turnover,
            validBetAmount
        } = {}
    } = d || {};
    if (!isNoLo && t0) return ''
    const v = (...a) => {
        let o = 0;
        for (let i of a) {
            if (i !== undefined) {
                o = +i || o;
                break
            }
        }
        return o;
    }
    return <div className={'sheet-ft'}>
        {validBetAmount !== undefined ? <>有效注额：<b>{v(validBetAmount)}</b></> : ''}
        注额：<b>{v(turnover, betAmount)}</b>
        盈亏：<b>{v(profit, netPnl)}</b>
    </div>
}

export const Aro = ({r = 0}) => {
    const ctx = useMemo(() => ({}), [])
    return <i className={'x-aro' + (r ? ' rig' : '')}
              onClick={() => {
                  const {p} = ctx;
                  p.scrollTo({
                      left: p.scrollLeft + (r ? 1 : -1) * 40,
                      behavior: 'smooth'
                  })
              }}
              ref={a => {
                  if (a && a.parentElement) ctx.p = a.parentElement.children[1];
              }}/>
}
export const Inf = ({children, cls = ''}) => {
    return <div className={'inf-tip ' + cls}>
        ?
        <div className={'cc'}>
            {children}
        </div>
    </div>
}
export const NoDate = ({children = '暂无数据', cls = ''}) => <div className={'no-data ' + cls}>
    <i/>
    <span>
        {children}
    </span>
</div>

export const SelIpt = ({value = [], onChange, data}) => {
    const ch = (a, b) => {
        const va = value.slice();
        if (a !== undefined) va[0] = a;
        if (b !== undefined) va[1] = b;
        onChange(va);
    }
    return <div className={'sel-ipt'}>
        <Select
            value={value[0]}
            items={data}
            onChange={v => ch(v)}
        />
        <input type={'text'} value={value[1]} onChange={change(v => ch(undefined, trim(v)))}/>
    </div>
}
export const PrizeNum = ({value, simple, fix}) => {
    let v = parseFloat(value);
    const isNa = isNaN(v);
    const negative = v < 0;
    if (fix) v = (v || 0).toFixed(fix)
    return <div
        className={'prz-num' + (v ? negative ? ' b' : '' : ' a') + (simple ? ' s' : '')}>{isNa ? '0' : v}</div>
}
export const PopUp = ({act, open, children, close, cls = '', read, onShow, onClose}) => {
    const [a, aa] = useState(0)
    useEffect(() => {
        const t = setTimeout(() => aa(act), 300);
        return () => clearTimeout(t);
    }, [act]);

    useEffect(() => {
        if (read) read({
            show() {
                open && open();
                onShow && onShow()
            },
            hide() {
                aa(0);
                setTimeout(() => {
                    close && close();
                    onClose && onClose()
                }, 300)
            },
        })
    }, [read])

    const bk = () => {
        aa(0);
        setTimeout(() => {
            close()
        }, 300)
    }
    return (act || a) ? <div className={'pop-up ' + (act ? 'a ' : '') + (a ? 'b ' : '') + cls}
                             onTouchStart={e => e.stopPropagation()}
                             onClick={e => {
                                 e.stopPropagation()
                                 bk();
                             }}>
        <div className={'ctx'}
             onClick={e => e.stopPropagation()}>
            {children}
        </div>
    </div> : null
}
export const Unread = widthStore(({userStore: {unread}}) => {
    useEffect(() => {
        getData('@unread')
    }, [])
    const un = unread > 99 ? 99 : unread;
    return <span className={'unread'} onClick={() => history.push('/msg')}>{un}</span>
})

export function randName() {
    const players = 'abcdefghijklmnopqrst1234567890';
    const dd = [];
    for (let i = 0; i < 3; i++) {
        const n = players[Math.floor(Math.random() * 30)] + players[Math.floor(Math.random() * 30)];
        dd.push(n)
    }
    return dd.join('').replace(/^(..)(...)/g, '$1***')
}

export const Captcha = widthStore(({userStore}, {useFor}) => {
    const {captchaCode, regCode, capLd} = userStore;
    const code = useFor ? regCode : captchaCode;
    const d = useMemo(() => ({}), []);
    useEffect(() => {
        if (useFor) {
            // d.useFor = useFor;
            // getData('@captcha', d)
        }
    }, [useFor, d]);

    return <div className={'captcha' + (capLd ? ' ld' : '')}
                onClick={capLd ? null : () => {
                    const d = {};
                    if (useFor) d.useFor = useFor;
                    getData('@captcha', d)
                }}
                style={{
                    backgroundImage: `url(${code})`
                }}/>
})


export const Switch = ({cls = ['sw-0', 'sw-1'], act = 0, onChange}) => {
    return <div className={'x-switch ' + (cls[act])} onClick={() => {
        onChange && onChange(1 - act)
    }}>
        <s/>
    </div>
}

export const jumEncode = a => {
    if (a) return userStore.jumper_page + '?' + (a.split("").map(a => (a.charCodeAt(0) + 10).toString(36)).join(""));
    return '';
}

export const SrvButton = ({children,cls}) => {
    return <div className={'x-select '+cls}>
        <div onClick={()=>service.showPop()}>客服{children}</div>
    </div>
}

export const ServiceWin = widthStore(({userStore: {username = ''}}) => {
        const [o, oo] = useState('srv0')
        const [s, ss] = useState(0)
        const [a, aa] = useState(0)
        const chats = {
            'srv0': '/srv.html?' + username,
            'srv1': '/serv.html?' + username
        }
        const src = useMemo(() => chats[o], [o])
        useEffect(() => {
            window.srv = o
            aa(0)
        }, [o])
        useEffect(() => {
            service.open = (v = window.srv || 'srv0') => {
                oo(v)
                ss(1)
            }
            service.hide = () => {
                ss(0)
            }
        }, [username])
        const name = {
            srv0: '线路一',
            srv1: '线路二',
        }[o] || ''
        const cls = v => o === v ? 'act' : ''
        return <div className={o + ' serv-win' + (s ? ' act' : '')}>
            <div className={'ti'}>
                <div className={'select'} onClick={() => aa(1 - a)}>
                    <span>在綫客服 [{name}]</span><i/>
                    <div onClick={e => e.stopPropagation()} className={a ? 'sa' : ''}>
                        <div className={cls('srv0')} onClick={() => oo('srv0')}>綫路一</div>
                        <div className={cls('srv1')} onClick={() => oo('srv1')}>綫路二</div>
                    </div>
                </div>

                <span onClick={() => service.hide()}>X</span></div>
            <div className={'srv'}>
                <div className={'srm'}>
                    {s ? <iframe src={src} key={o + s}/> : null}
                </div>
            </div>
        </div>
    }
)


export const Empty = ({
                          p = '/addBk',
                          t = '立即绑卡',
                          v = '您还没有绑定银行卡，请绑定银行卡。'
                      }) => {
    const curPth = window.location.pathname.replace('/h5', '')
    return <div className={'no-card x-sheet'}>
        <p><i/><span>{v}</span></p>
        <div className={'btn'}
             onClick={() => {
                 if (typeof p === 'string') history.push(p + '?' + curPth);
                 else p()
             }}
        >{t}
        </div>
    </div>
}

let c = 0;
export const useInput = (props) => {
    const {value} = props;
    const [v, vv] = useState(value);
    useEffect(() => {
        vv(value)
    }, [value])
    useEffect(() => {
        return () => {
            c = 0;
        }
    }, [])
    const {onChange, onPaste, onInput} = props;
    const pop = {
        ...props,
        onChange: null,
        onPaste(e) {
            if (onPaste) onPaste(e);
            if (onChange) onChange(e);
        },
        onInput(e) {
            if (onInput) onInput(e);
            if (c) {
                vv(e.target.value);
            } else if (onChange) {
                onChange(e);
            }
        },
        onCompositionStart() {
            if (isChrome) return
            c = 1
        },
        onCompositionEnd(e) {
            c = 0;
            onChange(e);
        },
    }
    pop.value = v;
    return pop
}

const isChrome = navigator.userAgent.indexOf('Chrome') > -1;
export const Input = props => {
    const pop = useInput(props)
    return <input {...pop} />
}


export const CheckBox = ({act, onChange, name}) => {
    return <div className={'x-check' + (act ? ' act' : '')} onClick={() => onChange(!act)}>
        <div>
            ✓
        </div>
        <span>{name}</span>
    </div>
}


export const UserLis = ({ls = [], onChange}) => {
    const l = ls.length;
    return <div className={'x-user-ls'}>
        {ls.map(([a], i) => <span onClick={() => l - 1 !== i && onChange(ls.slice(0, +1))} key={i}>{a}</span>)}
    </div>
}
